'use strict';

import Collection from './collection.js';
import Holiday from 'newModels/holiday.js';
import axios from 'axios';
import moment from 'moment';

export default class Holidays extends Collection {
    url() {
        return '/Holidays';
    }

    initialize(models, options) {
        this.model = Holiday;
        super.initialize(...arguments);

        this.options = _.defaults(options || {}, {
            all: true,
            enabled: true,
            company: app.company,
            location: options.location,
            dateStart: moment().startOf('year').toDate(),
            dateEnd: null,
            forceFetch: false
        });

        return this;
    }

    comparator(a, b) {
        return moment(a.get('date')).isBefore(b.get('date')) ? -1 : 1;
    }

    fetch({force = false} = {}) {
        const models = [];
        let enabledHolidays = Promise.resolve([]);
        let disabledHolidays = Promise.resolve([]);

        if (!this.options.company) {
            throw new Error(`Can't fetch holidays for no company`);
        }

        if (this.options.all || this.options.enabled) {
            enabledHolidays = axios.get(this.finalUrl() + '/enabled', {
                params: {
                    companyId: this.options.company.id,
                    locationId: this.options.location,
                    dateStart: this.options.dateStart,
                    dateEnd: this.options.dateEnd,
                    force: force || this.options.forceFetch
                },
                headers: {'Authorization': app.user.getAccessToken().id}
            }).then(r => r.data.results);
        }

        if (this.options.all || !this.options.enabled) {
            disabledHolidays = axios.get(this.finalUrl() + '/disabled', {
                params: {
                    companyId: this.options.company.id,
                    locationId: this.options.location,
                    dateStart: this.options.dateStart,
                    dateEnd: this.options.dateEnd,
                    force: force || this.options.forceFetch
                },
                headers: {'Authorization': app.user.getAccessToken().id}
            }).then(r => r.data.results);
        }

        return Promise.all([enabledHolidays, disabledHolidays])
            .then(([enabled, disabled]) => {
                disabled = disabled.map(holiday => {
                    holiday.enabled = false;
                    return holiday;
                });
                models.push(...enabled, ...disabled);
                // If we are not silent the collection might flag models as
                // dirty if they have changed.
                this.reset(models, {silent: true});
                this.trigger('sync');
                return this;
            });
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/holidays.js